import {createContext} from "react"

const fns = {}
const add = (name, fn) => {
    fns[name] = fn
}
const dispatch = (name, n) => {
    fns[name] && fns[name](n)
}
const RefContext = createContext({add, dispatch})

export default RefContext
